import get from "lodash/get";

import {RUMGraphData} from "@/lib/queries/rum";
// @ts-expect-error legacy code
import {checkFeatures} from "@/pages/rum/v2/CheckFeatures.js";
// @ts-expect-error legacy code
import CheckRowSparkline from "@/pages/rum/v2/graphs/CheckRowSparkline.jsx";

interface RUMTTIOverTimeProps {
  rowData: JSON;
  graphData?: RUMGraphData[];
}

export const RUMTTIOverTime = ({rowData, graphData}: RUMTTIOverTimeProps) => {
  const {pageLoad} = checkFeatures;
  const timePoints = graphData ? graphData.map((datum) => datum["Time"]) : [];
  const pageLoadPoints = graphData ? graphData.map((datum) => get(datum, pageLoad.key)) : [];
  const pageLoadBaseline = get(rowData, pageLoad.baseline);
  return <CheckRowSparkline time={timePoints} feature={pageLoad} points={pageLoadPoints} baseline={pageLoadBaseline} />;
};
